module.exports = __webpack_public_path__ + "static/media/filter.c22d84e5.svg";